export const AGE_RANGE = ["0-7", "8-14", "15-18", "19-25", "26-35", "35+"];

export const CONSENT_STATUS_KEYS = [
  "number_of_pending",
  "number_of_approved",
  "number_of_rejected",
  "number_of_self_consents",
  "number_of_revoked_rejections",
];

export const CONSENT_STATUS_KEYS_MAP: { [key: string]: string } = {
  number_of_pending: "Pending",
  number_of_approved: "Approved",
  number_of_rejected: "Rejected",
  number_of_revoked_rejections: "Revoked Re.",
  number_of_revoked_approvals: "Revoked Ap.",
  number_of_self_consents: "Self",
};

export const CONSENT_STATUS = ["Pending", "Approved", "Rejected", "Self", "Revoked Re.", "Revoked Ap."];

export const TIME_RANGE: Record<string, number> = {
  now: 0,
  "10mins": 0,
  "15mins": 0,
  "20mins": 0,
  "25mins": 0,
};

export const TIME_UNITS: { [key: string]: any } = {
  minutes: 'min',
  hours: 'hr',
  days: 'day',
};